export default __webpack_public_path__ + "2c45c5bd1b67d087e92e94a0e428bb18.svg";